import {SelectData} from "../../../../../../../core/types/records-table.types";

export const prioritySelectData: SelectData[] = Array.from({ length: 99 }, (_, index) => {
  const number = index + 1;
  return {
    id: number,
    value: number.toString(),
    display: true,
    color: null
  };
});
